import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { AuthenticatedFetchSubprovider, BitskiEngine } from 'bitski-provider';
import { BITSKI_RPC_BASE_URL, BITSKI_TRANSACTION_API_BASE_URL, BITSKI_WEB_BASE_URL } from '../constants';
import { BitskiTransactionSigner } from '../signing/transaction-signer';
import { AuthenticatedCacheSubprovider } from '../subproviders/authenticated-cache';
import { RemoteAccountSubprovider } from '../subproviders/remote-accounts';
import { RestFetchSubprovider } from '../subproviders/rest-fetch';
import { SignatureSubprovider } from '../subproviders/signature'; // Predicate to determine if the token provider is an AuthProvider

function isAuthProvider(object) {
  return object.getUser !== undefined;
}

export var BitskiBrowserEngine = /*#__PURE__*/function (_BitskiEngine) {
  _inherits(BitskiBrowserEngine, _BitskiEngine);

  var _super = _createSuper(BitskiBrowserEngine);

  function BitskiBrowserEngine(clientId, tokenProvider, sdkVersion, network) {
    var _this;

    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    _classCallCheck(this, BitskiBrowserEngine);

    _this = _super.call(this, options);
    options = options || {};
    _this.network = network;
    _this.clientId = clientId;
    _this.sdkVersion = sdkVersion;
    _this.apiBaseUrl = options.apiBaseUrl || BITSKI_TRANSACTION_API_BASE_URL;
    _this.webBaseUrl = options.webBaseUrl || BITSKI_WEB_BASE_URL;
    _this.tokenProvider = tokenProvider;
    var defaultBitskiHeaders = {
      'X-API-KEY': _this.clientId,
      'X-CLIENT-ID': _this.clientId,
      'X-CLIENT-VERSION': _this.sdkVersion
    };
    _this.headers = defaultBitskiHeaders;
    _this.rpcHeaders = {};

    if (options && options.additionalHeaders) {
      _this.headers = Object.assign({}, options.additionalHeaders, _this.headers);
      _this.rpcHeaders = options.additionalHeaders;
    }

    if (_this.network && _this.network.rpcUrl.includes('bitski.com')) {
      _this.rpcHeaders = Object.assign({}, _this.rpcHeaders, defaultBitskiHeaders);
    }

    _this.signer = new BitskiTransactionSigner(_this.webBaseUrl, _this.apiBaseUrl, _this.headers, options.callbackURL);

    _this.addSubproviders();

    return _this;
  }

  _createClass(BitskiBrowserEngine, [{
    key: "addSubproviders",
    value: function addSubproviders() {
      // Used for eth_accounts calls
      var accountsProvider = new RemoteAccountSubprovider("".concat(BITSKI_RPC_BASE_URL, "/mainnet"), false, this.tokenProvider, this.headers); // Used for all other calls

      var fetchSubprovider = new AuthenticatedFetchSubprovider(this.network.rpcUrl, false, this.tokenProvider, this.rpcHeaders); // Respond to some requests via userinfo object if available

      if (isAuthProvider(this.tokenProvider)) {
        var cacheSubprovider = new AuthenticatedCacheSubprovider(this.tokenProvider, this);
        this.addProvider(cacheSubprovider);
      } // Ensure that whenever accounts are requested, they go through Bitski


      this.addProvider(accountsProvider); // Respond to requests that need signed with an iframe

      var signatureSubprovider = new SignatureSubprovider(this.network, this.signer, this.tokenProvider);
      this.addProvider(signatureSubprovider); // Respond to block request via REST is using Bitski RPC endpoint

      if (this.network.rpcUrl.startsWith('https://api.bitski.com')) {
        var blockProvider = new RestFetchSubprovider({
          rpcUrl: this.network.rpcUrl,
          defaultHeaders: this.headers
        });
        this.addProvider(blockProvider);
      } // Finally, add our basic HTTP provider


      this.addProvider(fetchSubprovider);
    }
  }]);

  return BitskiBrowserEngine;
}(BitskiEngine);